var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUnderline = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "stroke",
    width: 19.272,
    height: 20.43,
    viewBox: "0 0 19.272 20.43",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-173.043 -149.771)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.901,
    height: 4.834,
    rx: 2.417,
    transform: "translate(181.508 157.678) rotate(-48.197)",
    strokeWidth: 1.8,
    stroke: "#324655",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.901,
    height: 4.834,
    rx: 2.417,
    transform: "translate(174.314 165.708) rotate(-48.197)",
    strokeWidth: 1.8,
    stroke: "#324655",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 4.831,
    x2: 4.326,
    transform: "translate(180.446 157.649)",
    fill: "none",
    stroke: "#324655",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUnderline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/underline.b3c295b1.svg";
export { ForwardRef as ReactComponent };